import { render, staticRenderFns } from "./CenteredFormLayout.vue?vue&type=template&id=2a16f616&scoped=true"
var script = {}
import style0 from "./CenteredFormLayout.vue?vue&type=style&index=0&id=2a16f616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16f616",
  null
  
)

export default component.exports